import React from "react";

const Toast = ({ message, type }) => {
  return (
    <div className={`custom-toast ${type}`}>
      {message}
    </div>
  );
};

export default Toast;
